module.exports = __webpack_public_path__ + "img/6_ava.3eaea098.jpg";